var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurve = function SvgCurve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 57"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    d: "M36.402 56.323c10.378-9.262 7.585-20.175 3.382-27.886-10.15-18.615-40.823-16.13-38.19-4.68S36.334 17.974 29.268.38"
  })));
};
export default SvgCurve;